export const defaultBundle = {
    "allTrueConditions": "Take all routes",
    "allTrueConditionsHelp": "Continue down multiple paths simultaneously.",
    "firstTrueConditions": "Take the first route that evaluates to true",
    "firstTrueConditionsHelp": "Continue down a single path.",
    "actualSize": "Actual Size",
    "enterValue": "Enter a value",
    "enterValueOrSelectParameter": "Enter a value or set to a parameter",
    "add": "Add",
    "andPlus": "+ And",
    "orPlus": "+ Or",
    "addNewDataField": "Add new data field",
    "addNewParameter": "Add new parameter",
    "addNewResponse": "Add new response",
    "addProperty": "Add Property",
    "align": "Align",
    "alignment": "Alignment",
    "allChangesLost": "All changes will be lost!",
    "alwaysTrue": "Always true",
    "alwaysTrueDisabled": "Only one route can be unconditional.",
    "angle": "Angle",
    "apply": "Apply",
    "arc": "Arc",
    "arrange": "Arrange",
    "arrow": "Arrow",
    "arrows": "Arrows",
    "automatic": "Automatic",
    "autosize": "Autosize",
    "background": "Background",
    "backgroundColor": "Background Color",
    "backgroundImage": "Background Image",
    "basic": "Basic",
    "block": "Block",
    "blockquote": "Blockquote",
    "bold": "Bold",
    "border": "Border",
    "bottom": "Bottom",
    "bottomAlign": "Bottom Align",
    "bottomLeft": "Bottom Left",
    "bottomRight": "Bottom Right",
    "bulletedList": "Bulleted List",
    "cancel": "Cancel",
    "center": "Center",
    "change": "Change",
    "circle": "Circle",
    "classic": "Classic",
    "close": "Close",
    "condition": "Condition",
    "conditionHelp": "JavaScript expression to be evaluated to true to transition to the next task.",
    "conditionalRouting": "Conditional routing",
    "connect": "Connect",
    "connection": "Connection",
    "constrainProportions": "Constrain Proportions",
    "containsValidationErrors": "Contains validation errors",
    "copy": "Copy",
    "copyConnect": "Copy on Connect",
    "create": "Create",
    "curved": "Curved",
    "custom": "Custom",
    "cut": "Cut",
    "dashed": "Dashed",
    "decreaseIndent": "Decrease Indent",
    "default": "Default",
    "delete": "Delete",
    "description": "Description",
    "diagram": "Diagram",
    "diamond": "Diamond",
    "diamondThin": "Diamond (thin)",
    "direction": "Direction",
    "distribute": "Distribute",
    "divider": "Divider",
    "documentProperties": "Document Properties",
    "done": "Done",
    "dotted": "Dotted",
    "doubleClickOrientation": "Double click to Change Orientation",
    "drawing": "Drawing{1}",
    "drawingEmpty": "Drawing is empty",
    "drawingTooLarge": "Drawing is too large",
    "duplicate": "Duplicate",
    "duplicateIt": "Duplicate {1}",
    "east": "East",
    "enterName": "Enter Name",
    "end": "End",
    "terminationStatus": "Termination status",
    "terminationStatusCompleted": "Completed",
    "terminationStatusCompletedHelp": "Terminate workflow and mark it as completed.",
    "terminationStatusFailed": "Failed",
    "terminationStatusFailedHelp": "Terminate workflow and mark it as failed.",
    "enterParameters": "Enter parameters",
    "enterPropertyName": "Enter Property Name",
    "entityRelation": "Entity Relation",
    "error": "Error",
    "errorSavingFile": "Error saving file",
    "expression": "Expression",
    "expressionPlaceholder": "${ }",
    "fieldName": "Field name",
    "fieldNameMustBeUnique": "Field name already exists. Must be unique.",
    "fieldNameMustBeValid": "Must contain only letters, digits, and underscores.",
    "selectParameterType": "Select parameter type",
    "parameterType.BOOLEAN": "Boolean",
    "parameterType.NUMBER": "Number",
    "parameterType.STRING": "String",
    "parameterType.TIME": "Time",
    "gap": "Gap",
    "general": "General",
    "glass": "Glass",
    "global": "Global",
    "gradient": "Gradient",
    "gradientColor": "Color",
    "grid": "Grid",
    "gridSize": "Grid Size",
    "group": "Group",
    "guides": "Guides",
    "heading": "Heading",
    "height": "Height",
    "help": "Help",
    "hidden": "Hidden",
    "hide": "Hide",
    "hideIt": "Hide {1}",
    "home": "Home",
    "horizontal": "Horizontal",
    "horizontalFlow": "Horizontal Flow",
    "horizontalTree": "Horizontal Tree",
    "html": "HTML",
    "id": "ID",
    "image": "Image",
    "images": "Images",
    "import": "Import",
    "increaseIndent": "Increase Indent",
    "inputParameter": "Input parameter",
    "inputParametersJsonObjectError": "Input parameters must be a JSON object.",
    "enterOrSelectParameter": "Enter a value or reference a parameter...",
    "parameters": "Parameters",
    "inputParameters": "Input parameters",
    "insert": "Insert",
    "insertHorizontalRule": "Insert Horizontal Rule",
    "insertRowAfter": "Insert Row Below",
    "insertRowBefore": "Insert Row Above",
    "invalidName": "Invalid name",
    "invalidOrMissingFile": "Invalid or missing file",
    "isometric": "Isometric",
    "italic": "Italic",
    "landscape": "Landscape",
    "laneColor": "Lane color",
    "layers": "Layers",
    "layout": "Layout",
    "left": "Left",
    "leftAlign": "Left Align",
    "leftToRight": "Left to Right",
    "line": "Line",
    "lineJumps": "Line jumps",
    "lineend": "Line End",
    "lineheight": "Line Height",
    "linestart": "Line Start",
    "linewidth": "Linewidth",
    "loading": "Loading",
    "manual": "Manual",
    "middle": "Middle",
    "misc": "Misc",
    "more": "More",
    "moreResults": "More Results",
    "move": "Move",
    "moveSelectionTo": "Move Selection to {1}",
    "mustHaveFieldType": "Must have a field type",
    "mustNotBeBlank": "Must not be blank",
    "name": "Name",
    "navigation": "Navigation",
    "new": "New",
    "noColor": "No Color",
    "noFiles": "No files",
    "noMoreResults": "No more results",
    "noResultsFor": "No results for '{1}'",
    "none": "None",
    "normal": "Normal",
    "north": "North",
    "numberedList": "Numbered List",
    "ok": "OK",
    "opacity": "Opacity",
    "open": "Open",
    "openArrow": "Open Arrow",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "options": "Options",
    "or": "Or",
    "organic": "Organic",
    "orthogonal": "Orthogonal",
    "outline": "Outline",
    "outputParameters": "Output parameters",
    "oval": "Oval",
    "parameter": "Parameter",
    "parameterName": "Parameter name",
    "pageScale": "Page Scale",
    "pageSetup": "Page Setup",
    "fork": "Fork",
    "join": "Join",
    "pageView": "Page View",
    "pages": "Pages",
    "panTooltip": "Space+Drag to Scroll",
    "paperSize": "Paper Size",
    "paste": "Paste",
    "pasteHere": "Paste Here",
    "pattern": "Pattern",
    "perimeter": "Perimeter",
    "plusTooltip": "Drag to connect",
    "portrait": "Portrait",
    "position": "Position",
    "posterPrint": "Poster Print",
    "preview": "Preview",
    "print": "Print",
    "radialTree": "Radial Tree",
    "redo": "Redo",
    "removeFormat": "Clear Formatting",
    "removeIt": "Remove {1}",
    "rename": "Rename",
    "renameIt": "Rename {1}",
    "replace": "Replace",
    "replaceExistingDrawing": "Replace existing drawing",
    "replaceIt": "{1} already exists. Do you want to replace it?",
    "reset": "Reset",
    "resetView": "Reset View",
    "responseName": "Response name",
    "responseNameMustBeUnique": "Response name already exists. Must be unique.",
    "reverse": "Reverse",
    "right": "Right",
    "rightAlign": "Right Align",
    "rightToLeft": "Right to Left",
    "rotate": "Rotate",
    "rotateTooltip": "Click and drag to rotate, click to turn by 90 degrees",
    "rotation": "Rotation",
    "rounded": "Rounded",
    "routing": "Routing",
    "routingTabProperties": "Properties",
    "save": "Save",
    "saveAs": "Save as",
    "saved": "Saved",
    "launch": "Launch",
    "scrollbars": "Scrollbars",
    "search": "Search",
    "searchShapes": "Search Shapes",
    "selectAll": "Select All",
    "selectEdges": "Select Routings",
    "selectFont": "Select a Font",
    "selectNone": "Select None",
    "selectParameter": "Select parameter",
    "selectParameters": "Select parameters",
    "selectResponse": "Select response",
    "selectVertices": "Select Tasks",
    "shadow": "Shadow",
    "shape": "Shape",
    "sharp": "Sharp",
    "sidebarTooltip": "Click to expand. Drag and drop shapes into the diagram. Shift+click to change selection. Alt+click to insert and connect.",
    "simple": "Simple",
    "simpleArrow": "Simple Arrow",
    "size": "Size",
    "solid": "Solid",
    "sourceSpacing": "Source Spacing",
    "south": "South",
    "spacing": "Spacing",
    "start": "Start",
    "task": "User Task",
    "http": "HTTP Task",
    "jq": "JQ Task",
    "testJQFilter": "Test with Input Parameters",
    "wait": "Wait Task",
    "emailTask": "Email Task",
    "mapTask": "Map Task",
    "email": "Email",
    "emailFromName": "From name",
    "emailToAddresses": "To",
    "emailCcAddresses": "Cc",
    "emailBccAddresses": "Bcc",
    "emailReplyToAddresses": "Reply-to",
    "emailSubject": "Subject",
    "emailHtml": "HTML body",
    "emailText": "Text body",
    "emailAttachments": "Attachment IDs",
    "emailAddToAddress": "Add to",
    "emailAddCcAddress": "Add cc",
    "emailAddBccAddress": "Add bcc",
    "emailAddReplyToAddress": "Add reply-to",
    "emailAddAttachment": "Add attachment",
    "emailRemoveAddress": "Remove",
    "emailRemoveAttachment": "Remove",
    "aiChatTask": "AI Chat Task",
    "jsonDocumentReaderTask": "JSON Reader Task",
    "textDocumentReaderTask": "Text Reader Task",
    "htmlDocumentReaderTask": "HTML Reader Task",
    "markdownDocumentReaderTask": "Markdown Reader Task",
    "yamlDocumentReaderTask": "YAML Reader Task",
    "taskTabDocumentReader": "Configuration",
    "jsonConverterTask": "JSON Converter Task",
    "taskTabJsonConverter": "Configuration",
    "jsonConverterSourceExpression": "Source expression",
    "jsonConverterSourceType": "Source type",
    "jsonConverterSourceTypePlaceholder": "Select source type",
    "jsonConverterSourceTypeJSONHelp": "Reads a JSON file and writes its data to a complete converted.json file. Objects, arrays and other JSON values keep their structure. Select an existing file descriptor or file reference; inline objects and URLs are not accepted.",
    "jsonConverterSourceTypeYAMLHelp": "Reads one JSON-compatible YAML document from an existing file into a complete converted.json file. Mappings become JSON objects and sequences become arrays. Inline text and URLs are not accepted. The source must fit the lower of your organization's allowance and 12,582,915 bytes (12 MiB plus a 3-byte UTF-8 byte-order mark); comments and whitespace count. The independent 3,145,728-code-point safeguard also applies.",
    "jsonConverterSourceTypeXMLHelp": "Reads an XML file and writes its elements and attributes as JSON data to a complete converted.json file. Repeated elements become arrays. This is not a lossless XML round trip. Select an existing file descriptor or file reference; inline XML text and URLs are not accepted.",
    "jsonConverterSourceTypeCSVHelp": "Reads a CSV file using the first row as field names and later rows as objects in a JSON array. Cell values stay text. Writes the array to a complete converted.json file. Select an existing file descriptor or file reference; inline CSV text and URLs are not accepted.",
    "jsonConverterHelpTitle": "Learn about JSON Converter",
    "jsonConverterPurposeHelp": "Convert an existing JSON, YAML, XML or header-row CSV file into a JSON file for structured-data processing. Use an HTTP task first when you need to download a file.",
    "jsonConverterSourceHelp": "Choose JSON, YAML, XML or CSV as Source type, then map the file into Input Parameters and enter one complete expression such as ${source}. The selected type determines how the file is read; its filename and content type do not choose the format. Select a file descriptor from a previous task or a complete swf:file reference. URLs, inline text and lists of files are not accepted.",
    "jsonConverterOutputHelp": "Output contains a swf:file descriptor for converted.json, even for a small result. A JQ task can load that file as text and use fromjson to process its JSON. Document Readers serve a different purpose: they extract text documents for AI and search.",
    "jsonConverterLimitsHelp": "Source files normally allow 5 MiB on Free and 20 MiB on Team; your organization's allowance may differ. YAML also has a separate 12,582,915-byte source ceiling, and the lower allowance applies. Existing format safeguards, output-file and shared-storage allowances still apply. Conversion does not increase a later task's input allowance or an AI model's context limit.",
    "jsonConverterRecoveryHelp": "Choose the Source type matching the file's actual contents. YAML must contain one JSON-compatible document; XML conversion does not preserve the original XML representation. If conversion fails, correct the chosen type or source, or reduce its size before retrying. A partial JSON file is never returned.",
    "documentReaderSourceExpression": "Source expression",
    "documentReaderCharset": "Character set",
    "documentReaderPointer": "Pointer",
    "documentReaderKeysToUse": "Keys to use",
    "documentReaderSelector": "HTML selector",
    "documentReaderSeparator": "Text separator (default: line break)",
    "documentReaderAllElements": "Read all body text",
    "documentReaderGroupByElement": "One document per selected element",
    "documentReaderIncludeLinkUrls": "Include link URLs",
    "documentReaderMetadataTags": "Metadata tags",
    "documentReaderHorizontalRuleCreateDocument": "Split at horizontal rules",
    "documentReaderIncludeCodeBlock": "Group fenced code with preceding text",
    "documentReaderIncludeBlockquote": "Group block quotes with preceding text",
    "documentReaderJSONHelpTitle": "Learn about JSON document reader",
    "documentReaderJSONHelp": "Read JSON objects or an array of objects from inline input or an existing UTF-8 JSON file.",
    "documentReaderSelectionHelp": "Choose Pointer or Keys to use, not both. Leave both blank to read each full object or mapping. Pointer uses /records to select a section, with ~0 for ~ and ~1 for / in a key. Keys to use chooses top-level properties for document text, not Page form fields. Missing keys can fall back to the full mapping text, so this is not a redaction or security control.",
    "documentReaderTextHelpTitle": "Learn about Text document reader",
    "documentReaderTextHelp": "Read plain text from inline input or an existing text file into one document.",
    "documentReaderTextOptionsHelp": "Inline text uses UTF-8. For a file encoded differently, enter its character set, such as UTF-16. Leave Character set blank for UTF-8.",
    "documentReaderHTMLHelpTitle": "Learn about HTML document reader",
    "documentReaderHTMLHelp": "Read text from inline HTML or an existing HTML file. Use a selector such as body or article to choose a containing section; narrow selectors leave out other content. Character set applies to files and defaults to UTF-8.",
    "documentReaderHTMLSelectionHelp": "By default, selected text is combined into one document, joined with Text separator. It starts as a line break; clearing it joins text without a separator. One document per selected element creates separate documents and ignores Text separator. Read all body text takes precedence over HTML selector, One document per selected element and Text separator.",
    "documentReaderHTMLMetadataHelp": "Metadata tags default to description and keywords. Include link URLs stores link URLs as JSON text in linkUrls. A relative link that cannot be resolved may appear as an empty entry. Leave the checkbox off when link metadata is not needed.",
    "documentReaderMarkdownHelpTitle": "Learn about Markdown document reader",
    "documentReaderMarkdownHelp": "Read Markdown from inline text or an existing UTF-8 Markdown file.",
    "documentReaderMarkdownOptionsHelp": "Split at horizontal rules starts a new document at each rule. Group fenced code with preceding text and Group block quotes with preceding text combine that content with the text before it. A fenced code block still ends that document. Unchecked grouping keeps separate records; it does not remove content.",
    "documentReaderMarkdownRecoveryHelp": "Indented code and raw HTML blocks cause a read failure. Use fenced code instead of indented code, or choose an HTML document reader or Text document reader for that content.",
    "documentReaderSourceHelp": "Fetch remote content with an HTTP task first. Map the content or an authorized workflow file into Input parameters, then select that field with Source expression, for example ${source}. Do not enter a URL or literal content in Source expression.",
    "documentReaderYAMLHelpTitle": "Learn about YAML document reader",
    "documentReaderYAMLHelp": "Read one UTF-8 YAML document from inline text or an existing workflow file. Read the root mapping or sequence of mappings, or use Pointer to select that section. Each selected mapping becomes one document in source order; an empty selected sequence produces an empty result.",
    "documentReaderYAMLValuesHelp": "Document text is converted from the normalized mapping. Without active Keys to use, swfSourceJson metadata retains its full normalized JSON; key selection omits that structure. Original YAML comments and formatting are not retained. Native YAML 1.1-style values include yes, no, on and off as booleans. Quote values to keep them as text. Dates remain text; mapping names become text field names.",
    "documentReaderYAMLRecoveryHelp": "Use one document, not multiple documents separated by ---. Expand anchors, aliases and merge keys, remove explicit tags and duplicate field names, and keep all numbers finite across the entire source, even outside Pointer. The selected section must be a mapping or sequence containing only mappings. Correct a missing Pointer or unsupported selected value and retry. Full-source byte, nesting and output limits still apply.",
    "documentReaderResultHelp": "The result is always the complete documents.json file containing an array of documents, even for an empty result. Map the completed task's output['swf:file'] into a later task's Input parameters to use it.",
    "documentReaderLimitsHelp": "Source input is limited to 2 MiB on Free and 10 MiB on Team. Use a smaller source if it exceeds the allowance. Normal output-file and shared-storage allowances apply separately.",
    "aiVectorStoreTask": "Vector Store Task",
    "aiVectorSearchTask": "Vector Search Task",
    "aiVectorDeleteTask": "Vector Delete Task",
    "taskTabAIVectorStore": "Configuration",
    "workflowTabResources": "Vector Stores",
    "vectorStoreResource": "Vector store",
    "vectorStoreResourceSelect": "Select a vector store",
    "vectorStoreResourceHelp": "Choose a vector store configured in this workflow's Vector Stores tab. Store, Search, and Delete can reuse the same settings.",
    "vectorStoreResourceUnavailable": "Unavailable vector store",
    "vectorResourceAdd": "Add vector store",
    "vectorResourceRemove": "Remove vector store",
    "vectorResourceName": "Vector store name",
    "vectorResourceNameRequired": "Enter a vector store name.",
    "vectorResourceNameInvalid": "Choose a different vector store name.",
    "vectorResourceNameDuplicate": "Vector store name already exists. Choose another name.",
    "vectorResourceProviderRequired": "Choose a vector store provider.",
    "vectorResourceCredentialsRequired": "Choose vector store credentials.",
    "vectorResourceIndexNameRequired": "Enter a vector index name.",
    "vectorResourceHostRequired": "Enter a vector store host.",
    "vectorResourcePortRequired": "Enter a vector store port.",
    "vectorResourceCollectionNameRequired": "Enter a vector collection name.",
    "vectorResourceObjectClassRequired": "Enter a vector object class.",
    "vectorResourceContentFieldNameRequired": "Enter a vector content field name.",
    "vectorResourceConsistencyLevelRequired": "Choose a vector consistency level.",
    "vectorEmbeddingCredentialsRequired": "Choose embedding credentials.",
    "vectorEmbeddingProviderRequired": "Choose an embedding provider.",
    "vectorEmbeddingModelRequired": "Enter an embedding model.",
    "vectorEmbeddingDimensionsRequired": "Enter embedding dimensions.",
    "vectorEmbeddingEndpointRequired": "Enter an Azure embedding endpoint.",
    "vectorResourcePositiveNumber": "Enter a positive number.",
    "embeddingDimensions": "Dimensions",
    "embeddingDimensionsHelp": "Number of values in each embedding vector. Match the model output and vector index dimension.",
    "embeddingProviderHelp": "Choose a provider and model that create text embeddings. Use the same compatible model and dimensions when storing and searching documents.",
    "embeddingModelSelectionHelp": "Select an embedding model, enter its model ID, or use an expression such as ${embeddingModel} to choose it from this task's input. For Azure OpenAI, Mistral AI, and Ollama, enter the model or deployment name manually.",
    "embeddingModelListingFailed": "Unable to list embedding models. You can enter a model ID manually.",
    "vectorStoreDocumentsExpression": "Documents expression",
    "queryExpression": "Search query",
    "idsExpression": "Document IDs",
    "vectorStoreProvider": "Vector store provider",
    "vectorStoreSection": "Vector store",
    "vectorEmbeddingSection": "AI embedding",
    "vectorStoreProviderSelect": "Select a vector store provider",
    "vectorStoreProviderHelp": "Choose Pinecone, Qdrant or Weaviate and provide its connection settings and credentials. The embedding model also needs an organization-owned credential.",
    "vectorIndexName": "Index name",
    "vectorNamespace": "Namespace",
    "vectorContentFieldName": "Content field name",
    "vectorDistanceFieldName": "Distance metadata field name",
    "vectorHost": "Host",
    "vectorPort": "Port",
    "vectorCollectionName": "Collection name",
    "vectorObjectClass": "Object class",
    "vectorMetaFieldPrefix": "Metadata field prefix (leave blank for no prefix)",
    "vectorConsistencyLevel": "Consistency level",
    "vectorConsistencyLevelSelect": "Select a consistency level",
    "vectorTopK": "Top K results",
    "vectorTopKHelp": "Maximum search matches to return. Defaults to 4; enter 1-100.",
    "vectorSimilarityThreshold": "Similarity threshold",
    "vectorSimilarityThresholdHelp": "Minimum similarity score from 0 to 1. Defaults to 0; higher values require a closer match.",
    "vectorQueryExpressionHelp": "Enter search text or use a SimWorkflow expression such as <code>${question}</code> that resolves to search text.",
    "vectorIdsExpressionHelp": "Enter comma-separated IDs such as <code>id1, id2</code>, use <code>${documentIds}</code> for an ID list, <code>${['Store documents'].output.ids}</code> for inline Store IDs, or <code>${['Store documents'].output['swf:file']}</code> for an authorized Store attachment.",
    "taskIncomingRouting": "Incoming routing information",
    "taskOutgoingRouting": "Outgoing routing information",
    "routingParameters": "Routing parameters",
    "taskOutgoingRoute": "{1} to {2}",
    "blankRouteName": "<blank>",
    "taskResponses": "Responses",
    "taskTabGeneral": "General",
    "taskTabInputParameters": "Input Parameters",
    "taskTabProcessor": "Task Processor",
    "taskTabHttp": "Configuration",
    "taskTabAIModel": "AI Model",
    "aiProvider": "Provider",
    "providerEndpoint": "Endpoint",
    "providerEndpointHelp": "The endpoint from the Azure AI OpenAI <code>Keys and Endpoint</code> section under <code>Resource Management</code>.",
    "temperature": "Temperature",
    "temperatureHelp": "What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.",
    "responseJSONSchema": "Response JSON schema",
    "model": "Model",
    "modelHelp": "The model name or deployment name to use for the selected provider.",
    "modelSelect": "Select or enter a model",
    "chatModelListingFailed": "Unable to list chat models for the selected provider.",
    "aiProviderSelect": "Select an AI provider",
    "taskTabEmail": "Configuration",
    "aiChatUserMessage": "User",
    "aiChatUserMessages": "User messages",
    "aiChatUserMessagesHelp": "Prompts, questions, or task input context sent as user messages.",
    "aiChatSystemMessage": "System",
    "aiChatSystemMessages": "System messages",
    "aiChatSystemMessagesHelp": "Developer instructions that guide model behavior across the conversation.",
    "aiChatMessagesDivider": "And / Or",
    "aiChatMessagesTab": "Messages",
    "aiChatMemoryWindowLength": "Memory window (messages)",
    "aiChatMemoryWindowHelp": "Leave blank for no memory, or enter 2 to 100 messages to share history within this workflow run. A smaller window evicts older messages from the shared history. History is scheduled for deletion when the run finishes. Test AI chat is always stateless.",
    "aiChatMemoryWindowInvalid": "Enter a whole number from 2 to 100, or leave blank for no memory.",
    "aiChatModelTab": "Model",
    "aiChatMCPServersTab": "MCP servers",
    "aiChatRemoveMessage": "Remove",
    "chatModel": "Chat model",
    "topP": "Top P",
    "topPHelp": "Nucleus sampling value. Lower values keep the model focused on more likely tokens.",
    "topK": "Top K",
    "topKHelp": "Limits sampling to the top K most likely tokens when the provider supports it.",
    "responseJSONSchemaInvalidJson": "Enter a valid JSON object for the response JSON schema.",
    "mcpServers": "MCP servers",
    "mcpServer": "MCP server",
    "mcpServerSSEUnsupported": "SSE is no longer supported. Update this MCP server to Streamable HTTP before saving or running the workflow.",
    "mcpServerSwitchToStreamableHTTP": "Switch to Streamable HTTP",
    "mcpServerUrl": "Server URL",
    "mcpServerRequestTimeoutSeconds": "Request time out in seconds",
    "mcpServerToolFilter": "Tool filter",
    "mcpServerToolFilterPlaceholder": "Select one or more tools to filter",
    "mcpServerToolDiscovered": "tool discovered",
    "mcpServerToolsDiscovered": "tools discovered",
    "mcpServerToolsEmpty": "No tools discovered",
    "mcpServerToolsDiscoveryFailed": "Unable to connect to MCP server to list tools.",
    "aiChatAddMCPServer": "Add MCP server",
    "aiChatRemoveMCPServer": "Remove MCP server",
    "taskTabJQ": "JQ Filter",
    "jqFilterHelpPrefix": "Use JQ filter expression to process input parameters JSON data. See ",
    "jqFilterHelpLink": "JQ Manual",
    "jqFilterHelpSuffix": " to learn more.",
    "taskTabMap": "Configuration",
    "taskMapItemsExpression": "Map items JSONPath expression",
    "taskMapItemsExpressionHelp": "JSONPath expression selects an array within a JSON input parameters provided to a Map task.",
    "jqFilter": "Expression",
    "httpRequest": "HTTP request",
    "httpRequestTemplate": "HTTP request template",
    "httpRequestTemplateSearch": "Search HTTP request template",
    "httpUrl": "URL",
    "httpMethod": "Method",
    "httpHeaders": "Headers",
    "httpAddHeader": "Add header",
    "httpRemoveHeader": "Remove",
    "httpBodyMode": "Body",
    "httpBodyModeEmpty": "No body",
    "httpBodyModeText": "Text or expression",
    "httpBodyModeJson": "JSON",
    "httpBody": "Body content",
    "httpBodyInvalidJson": "Enter valid JSON before testing or saving this request.",
    "testRequest": "Test request",
    "httpResponse": "HTTP response: {1} {2}",
    "testAIChat": "Test AI chat",
    "aiChatResponse": "Chat response: {1} {2}",
    "taskTabWait": "Configuration",
    "waitSeconds": "Wait for duration in seconds",
    "waitSecondsExpression": "Wait for duration in seconds with expression",
    "waitTimestamp": "Wait until an absolute time",
    "waitTimestampExpression": "Wait until an absolute time with expression",
    "taskTabProcessorHelp": "A task processor provides the information and resources for a participant to complete a task in a workflow. A step processor can also accept input from the participant.",
    "taskConcurrency": "Map task concurrency",
    "taskMaxConcurrency": "Max concurrent tasks",
    "taskMaxConcurrencyHelp": "No limit on concurrent tasks if set to 0.",
    "taskMaxConcurrencyExpression": "Max concurrent tasks with expression",
    "page": "Page",
    "processorPage": "Select a page for step processor",
    "pageVersion": "Page version",
    "latestPageVersion": "Latest page version",
    "credentialsSelect": "Select a credentials",
    "credentials": "Credentials",
    "credentialsRefresh": "Refresh credentials",
    "credentialsRefreshFailed": "Could not refresh credentials. Try Refresh credentials again.",
    "credentialsUnavailable": "Selected credentials are unavailable. Choose an available credential or refresh again.",
    "credentialsRegionSuffix": " - {1}",
    "credentialsAWS": "AWS",
    "credentialsBEARER_TOKEN": "Bearer Token",
    "credentialsBASIC_AUTHENTICATION": "Basic Authentication",
    "credentialsAPI_KEY": "API Key Header",
    "credentialsOAUTH2": "OAuth 2.0",
    "credentialsAuthorizedSuffix": " - Authorized",
    "credentialsNotAuthorizedSuffix": " - Not authorized",
    "connectionTimeoutSeconds": "Connection time out in seconds",
    "readTimeoutSeconds": "Read time out in seconds",
    "workflowTimeoutSeconds": "Time out in seconds",
    "workflowTimeoutSecondsHelp": "No time outs if set to 0.",
    "workflowMaxConcurrency": "Max concurrent workflows",
    "workflowMaxConcurrencyHelp": "No limit on concurrent workflows if set to 0.",
    "workflowTabStartForm": "Launch Page",
    "workflowStartPage": "Starter page",
    "workflowStartPageSelect": "Select a launch page",
    "workflowStartPageHelp": "When you start a workflow, the launch page is displayed. Submitted form fields become workflow input.",
    "workflowTabErrorHandling": "Error Handling",
    "workflowTabErrorHandlingHelp": "Workflow to be run on current Workflow failure. Useful for cleanup or post actions on failure.",
    "failureWorkflow": "Workflow definition",
    "failureWorkflowSelect": "Select a workflow definition",
    "failureWorkflowVersion": "Workflow definition version",
    "failureWorkflowVersionSelect": "Latest workflow definition version",
    "workflowTabWebhookSettings": "Webhook Settings",
    "workflowTabScheduleTrigger": "Schedule Trigger",
    "workflowTabVariables": "Variables",
    "workflowTabShareSettings": "Share Settings",
    "taskTabRouting": "Routing",
    "taskErrorHandling": "Retry",
    "taskErrorHandlingHelp": "Task can encounter runtime errors. Errors can arise because of workflow definition issues, task failures or because of transient issues, such as network partition events.",
    "taskErrorHandlingType": "Retry on errors",
    "taskErrorHandlingNo": "No retry and fail the whole workflow",
    "taskErrorHandlingYes": "Retry the task when errors occur",
    "retryIntervalSeconds": "Interval in seconds",
    "retryIntervalSecondsHelp": "The number of seconds before the first retry attempt.",
    "retryMaxAttempts": "Max attempts",
    "retryMaxAttemptsHelp": "The maximum number of retry attempts.",
    "retryBackoffRate": "Backoff rate",
    "retryBackoffRateHelp": "The multiplier by which the retry interval increases with each attempt.",
    "retryExampleIntro": "An example of a retry which will make 2 retry attempts after waits of 3 and 4.5 seconds:",
    "retryExampleIntervalSecondsValue": ": 3",
    "retryExampleMaxAttemptsValue": ": 2",
    "retryExampleBackoffRateValue": ": 1.5",
    "taskTabWorkflowOutput": "Workflow Output",
    "straight": "Straight",
    "strokeColor": "Line Color",
    "collectorTask": "Collector task",
    "collectorTaskHelp": "Combine the parallel paths into one place.",
    "style": "Style",
    "subscript": "Subscript",
    "superscript": "Superscript",
    "takeRoutesOf": "Take routes of",
    "table": "Table",
    "targetSpacing": "Target Spacing",
    "text": "Text",
    "textAlignment": "Text Alignment",
    "textOpacity": "Text Opacity",
    "toBack": "To Back",
    "toFront": "To Front",
    "tooltips": "Tooltips",
    "top": "Top",
    "topAlign": "Top Align",
    "topLeft": "Top Left",
    "topRight": "Top Right",
    "transparent": "Transparent",
    "turn": "Rotate 90°",
    "uml": "UML",
    "underline": "Underline",
    "undo": "Undo",
    "url": "URL",
    "value": "Value",
    "version": "Version",
    "vertical": "Vertical",
    "verticalFlow": "Vertical Flow",
    "verticalTree": "Vertical Tree",
    "view": "View",
    "waypoints": "Waypoints",
    "west": "West",
    "width": "Width",
    "workflow": "Workflow",
    "workflowTabGeneral": "General",
    "workflowTabWorkflows": "Workflows",
    "workflowTabVersions": "Versions",
    "writingDirection": "Writing Direction",
    "zoom": "Zoom",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "taskErrors": "There were problems with this task definition",
    "routeErrors": "There were problems with this route definition",
    "routeMustConnectTasks": "Route must connect two tasks in the same graph.",
    "subMapErrors": "There were problems within this map definition",
    "subMapExit": "Exit Map: {1}",
    "current": "Current",
    "noVersions": "No versions found for this workflow definition. Publish to create a version.",
    "errorFetchingVersions": "We're unable to fetch workflow definition versions.",
    "errorLoadingEditor": "We're unable to load editor.",
    "pleaseTryAgain": "Please try again",
    "updatedBy": "Last modified by",
    "updatedOn": "Last modified on",
    "actions": "Actions",
    "restore": "Restore",
    "workflowOutput": "Workflow output",
    "workflowOutputHelp": "Workflow output is a JSON object. Values can use expressions such as ${workflow.input.requestId}, ${TaskName.input.field}, or ${TaskName.output.result}.",
    "taskNameMustBeUnique": "Task definition name already exists. Must be unique within workflow definition.",
    "taskNameMustNotBlank": "Please enter a task definition name",
    "taskNotReachableFromStart": "Task cannot be reached from the start/launch task",
    "graphNoTasks": "The graph '{1}' contains no tasks. Graphs should always contain at least one task.",
    "graphStartTaskMustExist": "The graph start task no longer exists.",
    "taskIncorrectlyNested": "Route from '{1}' to '{2}' is incorrectly nested.",
    "taskAmbiguousSplitJoin": "Ambiguous split/join pairing, split task '{1}' can match join task '{2}' or '{3}'.",
    "taskNoCollectorTask": "No collector task found for parallel task '{1}'",
    "openApisSearch": "Search APIs",
    "authorizeCredentials": "Authorize your account with this credentials",
    "reauthorizeCredentials": "Reauthorize your account with this credentials",
    "addWaypoint":"Add Waypoint",
    "removeWaypoint":"Remove Waypoint",
    "clearWaypoints":"Clear Waypoints"
}
